import React from "react";
import { Form } from "react-bootstrap";
import "./style.css"

interface DescriptionOfNonconformanceOrObservationProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  disabled : boolean
}

const DescriptionOfNonconformanceOrObservation: React.FC<DescriptionOfNonconformanceOrObservationProps> = ({
  formData,
  setFormData,
  disabled
}) => {
  const handleDescriptionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setFormData((prevData: { DescriptionOfNonconformanceOrObservation: any }) => ({
      ...prevData,
      DescriptionOfNonconformanceOrObservation: {
        ...prevData.DescriptionOfNonconformanceOrObservation,
        description: e.target.value,
      },
    }));
  };

  return (
    <div className="p-4">
     <Form.Control
        as="textarea"
        rows={7}
        placeholder="Please list any other applicable references here"
        className="mt-3"
        disabled = {disabled}
        value={formData.DescriptionOfNonconformanceOrObservation?.description || ""}
        onChange={handleDescriptionChange}
      />
    </div>
  );
};

export default DescriptionOfNonconformanceOrObservation;
